const PROVIDERS = {
    TP: 'TP',
    ECOTEK: 'Ecotek',
    SHEET: 'Excel',
}

const PROVIDER_LABEL = {
    [PROVIDERS.TP]: 'TP',
    [PROVIDERS.ECOTEK]: 'Ecotek',
}

export {
    PROVIDERS,
    PROVIDER_LABEL,
}
